module.exports = __webpack_public_path__ + "media/es.cc1b41b0.svg";